import React from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { useTheme } from '../contexts/ThemeContext';

const ThemeToggle = () => {
  const { isDarkMode, toggleDarkMode, theme, changeTheme, themes, getThemeColors } = useTheme();
  const colors = getThemeColors();

  return (
    <div className="d-flex align-items-center">
      {/* Theme Selector */}
      <Dropdown className="me-3">
        <Dropdown.Toggle
          variant="outline-secondary"
          size="sm"
          style={{
            borderColor: colors.border,
            color: colors.text,
            background: colors.surface
          }}
        >
          <i className="fas fa-palette me-1"></i>
          {theme.charAt(0).toUpperCase() + theme.slice(1)}
        </Dropdown.Toggle>
        <Dropdown.Menu
          style={{
            background: colors.surface,
            border: `1px solid ${colors.border}`
          }}
        >
          {themes.map((themeName) => (
            <Dropdown.Item
              key={themeName}
              onClick={() => changeTheme(themeName)}
              active={theme === themeName}
              style={{
                color: colors.text,
                background: theme === themeName ? colors.primary : 'transparent'
              }}
            >
              <i className={`fas fa-${themeName === 'abacus' ? 'calculator' : 'cog'} me-2`}></i>
              {themeName.charAt(0).toUpperCase() + themeName.slice(1)}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>

      {/* Dark Mode Toggle */}
      <Button
        variant="outline-secondary"
        size="sm"
        onClick={toggleDarkMode}
        style={{
          borderColor: colors.border,
          color: colors.text,
          background: colors.surface
        }}
        title={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
      >
        <i className={`fas fa-${isDarkMode ? 'sun' : 'moon'}`}></i>
      </Button>
    </div>
  );
};

export default ThemeToggle;
